/** @format */

import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { _$, Dialog, Form, FormItem, Input, Message } from '@king-design/react'
import { saveScriptInfo } from '../container'

interface ImportDialogProps {
  className?: string
  visible: boolean
  onClose: (data?) => void
}

const ImportDialog: React.FC<ImportDialogProps> = ({ className, visible, onClose }) => {
  const remarkForm = useRef(null)
  const [importData, setImportData] = useState('')

  const formSubmit = async () => {
    const validate = await remarkForm?.current?.validate()
    if (validate) {
      let data
      try {
        data = JSON.parse(importData)
      } catch (error) {
        Message.error(_$("数据格式不正确"))
      }
      const newCells = await saveScriptInfo(data?.cells)
      data.cells = newCells
      data.formData.name += '_Copy'
      Message.success(_$("导入成功"))
      onClose(data)
    }
  }

  return (
    <Dialog
      value={visible}
      width={600}
      title={_$('导入场景')}
      container={() => document.getElementById('scene_detail')}
      onChangeValue={show => {
        if (!show) {
          onClose()
          setImportData('')
        }
      }}
      ok={formSubmit}
    >
      <div className={className}>
        <Form ref={remarkForm}>
          <FormItem
            label={_$('导入内容')}
            value={importData}
            rules={{ required: true }}
            messages={{ required: _$("请填写操作导入内容") }}
          >
            <Input
              width={450}
              type="textarea"
              placeholder={_$('请填写操作导入内容')}
              rows={4}
              value={importData}
              onChangeValue={value => {
                setImportData(value)
              }}
            />
          </FormItem>
        </Form>
      </div>
    </Dialog>
  )
}

export default styled(ImportDialog)``
